<div class="container-fluid">
    <app-video-selector (videoToInsert)="selectVideo($event)"></app-video-selector>
</div>